/*window.addEventListener("DOMContentLoaded",()=>{
  
})*/
window.addEventListener("load",()=>{
  var activefilter=document.querySelector(".quantity-option-label-card.active .current-price").textContent;
  var buttonctsprice=document.querySelector(".cta-price");

  buttonctsprice.textContent=activefilter;
  if(document.querySelector(".subscription_choice_input"))
  {
  document.querySelector(".subscription_choice_input").click();
    
  }
  document.querySelector("span.cta-price").style.display="block";
   // document.querySelector(".compareatp").style.display="inline";
  if(document.querySelector(".subscription-widget")){
  document.querySelector(".subscription-widget").style.display="flex";
    
  }
})
window.addEventListener("click",(event)=>{
  if(event.target.classList.contains('quantity-option-label-card') || event.target.closest('.quantity-option-label-card')){
   const allLabelCards=document.querySelectorAll('.quantity-option-label-card');
   allLabelCards.forEach(el=>{
    el.classList.remove('active')
   })
   
    const labelCard = event.target.classList.contains('quantity-option-label-card') ? event.target : event.target.closest('.quantity-option-label-card')
  
    labelCard.classList.add("active")
  
  }

})


window.addEventListener("change",(event)=>{
  if(event.target.classList.contains('quantity-radio-input') || event.target.closest('.quantity-radio-input')){
   const currentQty= event.target.classList.contains('quantity-radio-input') ?event.target : event.target.closest('.quantity-radio-input');
const currentQtyGlued=currentQty.value.replace(" ","").toLowerCase();
//console.log("currentQtyGlued",currentQtyGlued)
  let currentOptions= Array.from(document.querySelectorAll(".product-page-info__options .product-options .option_group .product-options__section .product-options__value.active")).map(el=>el.dataset.originalValue)
if(currentQty){
  const currentQtyValue = currentQty.value;
  currentOptions.push(currentQtyValue) 

}
const qtyToBeSelected= document.querySelector(`[data-quantity-container] [data-value='${currentQtyGlued}']`);
qtyToBeSelected.click();

/*
console.log("currentOptionscurrentOptionscurrentOptionscurrentOptionscurrentOptions",currentOptions)

const currentVariant=findVariantDependingOnOptions(currentOptions);

console.log("currentVariantcurrentVariantcurrentVariantcurrentVariant",currentVariant)
const currentVariantId = currentVariant.id;
const singleProduct= document.querySelector('single-product.product-page-main');
singleProduct.setAttribute("data-product-variant-id",currentVariantId)*/

}

if(event.target.classList.contains('subscription_choice_input') || event.target.closest('.subscription_choice_input'))
{
  //console.log("mehmehmehmehmehmehmeh")
  const currentSellingPlanValue=Number(document.querySelector('[name="selling_plan"]:checked').value);
  const newVariant = getVariant(Number(productElement.getAttribute('data-product-variant-id')));
  if(currentSellingPlanValue){
    adjustPackaging(newVariant,true)

  }
  else{
    adjustPackaging(newVariant,false)


  }
}

})
const findVariantDependingOnOptions=(currentOptions)=>{


  const currentVariant=currentProduct.variants.find(v=>arraysAreEqual(v.options,currentOptions));
  return currentVariant
};
function arraysAreEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  
  return true;
}

const productElement = document.querySelector('single-product');

if (productElement) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-product-variant-id'
      ) {
        const newVariantId = Number(productElement.getAttribute('data-product-variant-id'));
      //  console.log('Promenila se varijanta:', newVariantId);
        adjustVariant(newVariantId)
      }
    }
  });

  observer.observe(productElement, {
    attributes: true,
    attributeFilter: ['data-product-variant-id'],
  });
}

const getVariant=(newVariantId)=>{
  const newCurrentVariant = currentProduct.variants.find(v=> v.id ==newVariantId);
return newCurrentVariant;
}
const adjustVariant=(newVariantId)=>{

    const newCurrentVariant = currentProduct.variants.find(v=> v.id ==newVariantId);
    //console.log('newCurrentVariant',newCurrentVariant)
    // Buy Now: keep disabled state in sync with variant availability (mirrors server-side render)
    document.querySelectorAll('[data-js-buy-now-button]').forEach(btn=>{
      if(newCurrentVariant && newCurrentVariant.available){
        btn.removeAttribute('disabled');
      }
      else{
        btn.setAttribute('disabled','disabled');
      }
    });
    adjustGalleryImages(newCurrentVariant);
    const hasSellingPlan=Number(document.querySelector('[name="selling_plan"]:checked')?.value)?true:false;
    adjustPackaging(newCurrentVariant,hasSellingPlan);

}
// Yeh bhi add kar end mein
const activeCard = document.querySelector(".quantity-option-label-card.active .current-price");
if (activeCard) {
    document.querySelector(".cta-price").textContent = activeCard.textContent;
}
const  adjustPackaging=(newCurrentVariant, useSellingplans)=>{
const currentVariantOptions = [newCurrentVariant.option1,newCurrentVariant.option2]
   // console.log("currentVariantOptions",currentVariantOptions)

    const allVariantsWithSameOptions = currentProduct.variants.filter(v=>v.option1 ==newCurrentVariant.option1 && v.option2 ==newCurrentVariant.option2)

    //console.log("allVariantsWithSameOptionsallVariantsWithSameOptions",allVariantsWithSameOptions)

    const customPackagesWrapper=document.querySelector(".custom_packages_wrapper");

    allVariantsWithSameOptions.forEach(v=>{
      const package=v.option3;
      const currentVariant=v;
      let price=0;
      let compareAtPrice=0;
      const packageWrapper=customPackagesWrapper.querySelector(`input[value*='${package}']`).closest(".quantity-option-label-card");

      // Sync sold-out state: grey out packages whose variant is unavailable (still clickable; ATC handles sold-out natively)
      packageWrapper.classList.toggle('is-unavailable', !currentVariant.available);

      if(currentVariant.selling_plan_allocations.length > 0 && useSellingplans){

        price=currentVariant.selling_plan_allocations[0].price;
        compareAtPrice=currentVariant.selling_plan_allocations[0].compare_at_price;
      }
      else{

        price=currentVariant.price;
        compareAtPrice=currentVariant.compare_at_price;

      }
    //  console.log("price",price);
      //console.log("compareAtPrice",compareAtPrice);

      const priceDom = packageWrapper.querySelector(".current-price");
      const comparePriceDom = packageWrapper.querySelector(".compare-price");
     const priceEl = priceDom.textContent;
     console.log('hiii',priceEl);

     
    // PURANA CODE (yeh hata)
priceDom.textContent = `${Shopify.formatMoney(price, theme.moneyFormat)} each`

// NAYA CODE (yeh laga)
const vrtTitle = priceDom.getAttribute('data-variant-title');
const unitCount = parseInt(vrtTitle) || 1;
const unitPrice = Math.round(price / unitCount);
priceDom.textContent = `${Shopify.formatMoney(unitPrice, theme.moneyFormat)} each`;

      if(comparePriceDom){
        if(compareAtPrice){
          comparePriceDom.style.display="inline";

          comparePriceDom.textContent=`${Shopify.formatMoney(compareAtPrice,theme.moneyFormat)}`
        }
        else{
          comparePriceDom.style.display="none";
        }
      }
     


      //${Shopify.formatMoney(data.update_variant.selling_plan_allocations[0].price,theme.moneyFormat)}</span> <span>${Shopify.formatMoney(data.update_variant.price,theme.moneyFormat)}


     

      
      
    })

}
const adjustGalleryImages=(variant)=>{
    const gallery=document.querySelector(".product-image-section .main-swiper");
    const variantImage = variant.featured_image.src;
    const imgToBeActive=Array.from(gallery.querySelectorAll('img')).find(img=> img.src.replace('_1024x1024','').includes(variantImage));
   const slideToBeActive=imgToBeActive.closest(".swiper-slide");
    let indx = 0;
    gallery.querySelectorAll(".swiper-slide").forEach((slide,index)=>{
        if(slide == slideToBeActive){
            indx=index;
        }
    })
   // console.log(indx)
    window.mainSwiper.slideTo(indx);
}



document.addEventListener('DOMContentLoaded', () => {
    const newVariant = getVariant(Number(productElement.getAttribute('data-product-variant-id')));
  adjustGalleryImages(newVariant);
});